import { render, staticRenderFns } from "./ProductFormatFull.vue?vue&type=template&id=2949d3ec&"
import script from "./ProductFormatFull.vue?vue&type=script&lang=js&"
export * from "./ProductFormatFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports